export default "__VITE_ASSET__eefc878d__"